import styled from "styled-components";
import { Container, ErrorBoxContainer } from "../Errorbox/Errorbox.style";
export const SuccessContainer = styled(Container)``

export const SuccessBoxContainer = styled(ErrorBoxContainer)``
